function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#4A4A4A",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.627 23.886H5.875V7h3.752v1.876H7.751V22.01h1.876zm15.624-1.876V8.876h-1.876V7h3.752v16.886h-3.752V22.01z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.708 9.917)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: "5.104",
  cy: "2.188",
  rx: "5.104",
  ry: "2.188"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.001 5.173A.957.957 0 000 5.22c0 1.21 2.285 2.19 5.104 2.19 2.82 0 5.104-.98 5.104-2.188a.958.958 0 000-.052v1.51c0 1.209-2.285 2.188-5.104 2.188S0 7.887 0 6.68V5.19l.001-.018z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.001 2.985A.957.957 0 000 3.034c0 1.208 2.285 2.187 5.104 2.187 2.82 0 5.104-.979 5.104-2.187a.958.958 0 000-.052v1.51c0 1.208-2.285 2.188-5.104 2.188S0 5.7 0 4.492V3.004l.001-.019zm0 4.375A.957.957 0 000 7.41c0 1.208 2.285 2.187 5.104 2.187 2.82 0 5.104-.979 5.104-2.187a.958.958 0 000-.052v1.51c0 1.208-2.285 2.188-5.104 2.188S0 10.075 0 8.867V7.38l.001-.019z"
})))));